import Swiper from "../../../vendors/swiper.min";

export const teaserSlider = {
    initSlider: function() {
        // function slickTeasers() {
        // 	var initializedSlickNewsletterSliders = $('.teaser-slider__slides.slick-initialized');
        // 	if (initializedSlickNewsletterSliders.length > 0 ) {
        // 		initializedSlickNewsletterSliders.each(function () {
        // 			if ( $(this)[0].slick ){
        // 				$(this).slick('unslick');
        // 			}
        // 		});
        // 	}
        $(".teaser-slider__slides").on("init", function() {
            // console.log("init", $(".teaser-slider__slides").find(".slick-list"));
            $(".teaser-slider__slides")
                .find(".slick-list")
                .removeAttr("aria-live");
        });
        $(".teaser-slider__slides").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 2000,
            autoplay: true,
            arrows: true
        });
        // }

        // const modul = document.querySelectorAll('.teaser-slider');
        // let teaSwiper = [];

        // [].forEach.call(modul, el => {

        // 	console.log('tea')

        // 	const swContainer = el.querySelector('.container');

        // 	teaSwiper.push(new Swiper(swContainer, {
        // 		wrapperClass: 'teaser-slider__slides',
        // 		slideClass: 'teaser-slider__slide'
        // // 		slidesPerView: 4,
        // // 		touchRatio: 1,
        // // 		a11y: true,
        // // 		keyboard: true,
        // // 		navigation: {
        // // 			nextEl: '.swiper-button-next',
        // // 			prevEl: '.swiper-button-prev'
        // // 		},
        // // 		breakpoints: {
        // // 			599: {
        // // 				slidesPerView: 1
        // // 			}
        // // 		 }
        // 	}));
        // });

        // tabs.forEach(t => {
        // 	t.addEventListener("click", infoTab.displayContent);
        // });
    }
};